
export const getUser = (data) => {
  return data.hasOwnProperty('user') ? data.user : { fullname: null }
}
export const getTag = (data) => {
  return data.hasOwnProperty('course_name') ? data.course_name : null
}
export const getName = (data) => {
  return data.hasOwnProperty('student_fullname') ? data.student_fullname : null
}
export const getComment = (data) => {
  return data.hasOwnProperty('student_comment') ? data.student_comment : null
}
export const getResponse = (data) => {
  return data.hasOwnProperty('student_comment') ? data.teacher_response : null
}
export const getCreatedAt = (data) => {
  return data.hasOwnProperty('created_at') ? data.created_at : null
}
export const getScore = (data) => {
  return data.hasOwnProperty('student_score') ? data.student_score : null
}

export const GetComment = (data) => {
  return {
    tag: getTag(data),
    name: getName(data),
    created_at: getCreatedAt(data),
    comment: getComment(data),
    response: getResponse(data),
    score: getScore(data)
  }
}
